import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0;
  float: left;

  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  float: left;
  align-items: center;
  background: ${({ theme }) => theme.colors.HEADER_BG};
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06);
  padding: 2rem 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
  }
`;

export const Right = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Title = styled.div`
  color: ${({ theme }) => theme.colors.HEADER_TEXT};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  font-size: 1.6rem;
  align-items: center;

  button {
    background: none;
    margin-right: 10px;
    background: rgba(255, 255, 255, 0.1);
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  div {
    display: flex;
    flex-direction: column;
  }

  h1 {
    font-size: 1.6rem;
    font-weight: 700;
  }

  h2 {
    font-size: 1rem;
    opacity: 0.3;
    font-weight: 400;
  }

  @media (max-width: 1024px) {
    margin-bottom: 5px;
    font-size: 18px;
    display: none;
  }
`;

export const PlusBtn = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  flex-direction: row;
  float: left;
  align-items: center;
  padding: 0rem 1rem;
  height: 60px;
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.colors.HEADER_PLUS};
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06);
  transition: all 0.5s ease;
  margin: 0px 0px 0px 40px;
  
  &:hover {
    background: #f5f5f5;
  }

  span {
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    margin-left: 0.5rem;
  }

  @media (max-width: 1024px) {
    margin: 0px;
    width: 100%;
  }
`;

export const Search = styled.div`
  display: flex;
  flex-direction: row;
  float: left;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06);
  padding: 0rem 1rem 0 0;
  height: 60px;
  width: 100%;
  max-width: 30rem;
  margin: 0px;
  border-radius: 10px;

  input {
    background: none;
    width: 100%;
    float: left;
    height: 60px;
    padding: 0 1.5rem;
    color: #333;
    font-size: 18px;
    border: none;
    font-weight: 700;
  }

  button {
    background: none;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  button.close {
    opacity: 0.6;
  }

  button.search {
    margin-left: 10px;
  }

  @media (max-width: 1024px) {
    margin: 0px 0px 10px 0;

    input {
      height: 60px;
      font-size: 1rem;
      padding: 0 1rem;
      border-radius: 0.6rem;
    }
  }
`;
